/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import { MetricItem } from 'enums/MetricItem'
import InsightViewOption, { InsightViewOptionStrings } from 'enums/InsightViewOption'
import MeasureType, { MeasureTypeStrings } from 'enums/MeasureType'

/* eslint-disable import/prefer-default-export */
export const getChildTypes = (
  viewOption: InsightViewOptionStrings,
  measureType: MeasureTypeStrings
) => {
  switch (viewOption) {
    case InsightViewOption.OWNED_PARTNERED_EARNED:
      return MetricItem.CHILDREN_OPE
    case InsightViewOption.OVERVIEW:
      switch (measureType) {
        case MeasureType.ENGAGEMENTS:
          return [MeasureType.COMMENTS, MeasureType.LIKES, MeasureType.VIEWS, MeasureType.DISLIKES]
        case MeasureType.POSTS:
        case MeasureType.UNIQUE_AUTHORS:
        default:
          return []
      }
    default:
      return []
  }
}
